import React from "react";
import styled from "styled-components";

const Section = styled.section`
  background: #fff;
  padding: 64px 0 48px 0;
  border-bottom: 1.5px solid #222;
`;

const Title = styled.h2`
  font-size: 2rem;
  font-weight: 800;
  color: #222;
  text-align: center;
  margin-bottom: 32px;
  letter-spacing: 1px;
`;

const MainFunctionalityText = styled.p`
  max-width: 900px;
  margin: 0 auto;
  color: #444;
  font-size: 1.15rem;
  text-align: center;
  line-height: 1.7;
  background: #f8f9fa;
  border: 1.5px solid #b28767;
  border-radius: 18px;
  padding: 32px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  box-sizing: border-box;
  @media (max-width: 600px) {
    font-size: 1rem;
    padding: 18px 4vw;
    width: 94vw;
    max-width: 94vw;
    margin: 0 auto;
    border-radius: 10px;
    position: static;
    left: unset;
    right: unset;
    transform: none;
  }
`;

const Features = () => (
  <Section id="features">
    <Title>Principal Funcionalidade</Title>
    <MainFunctionalityText>
      Nossa missão é potencializar o desenvolvimento de instituições
      educacionais e organizações, oferecendo assessoria administrativa e
      pedagógica de forma integrada, estratégica e humanizada. Atuamos no
      fortalecimento da gestão, na qualificação dos processos e na promoção de
      práticas pedagógicas inovadoras e inclusivas, sempre alinhadas às
      exigências legais e às necessidades reais da comunidade escolar.
      <br />
      <br />
      Mais do que uma empresa de assessoria educacional, buscamos ser parceiros
      na construção de ambientes de aprendizagem mais eficientes, acolhedores e
      transformadores, capazes de unir qualidade, propósito e sustentabilidade.
      <br />
      <br />
      Fazemos isso com escuta ativa, análise criteriosa, soluções personalizadas
      e compromisso com resultados que gerem impacto positivo e duradouro.
    </MainFunctionalityText>
  </Section>
);

export default Features;
